import { TaskDataStore } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { EntityHistory } from '@skinsoft/ui';
import { Component } from 'vue-property-decorator';

import { Task } from '@skinsoft/types';
import { toHistoryRecord$ } from '../../serializer/history';

@Component({
    components: {
        sEntityHistory: EntityHistory,
    },
    props: ['targetRouteName'],
    template: require('./task-history.html'),
})
export class TaskHistory extends ReactiveVue {
    public $taskDataStore: TaskDataStore;
    public historyStates = TaskDataStore.historyStates;
    public serializer = (task: Task) => toHistoryRecord$(task, undefined) // undefined just for avoiding problem with this at initialization
    public sortFields = TaskDataStore.sortFields;
    public targetRouteName;

    mounted() {
        // passing directlt this.$i18n.locale to the toFeatured inside the serializer arrow function
        // was not working as the "this" was not pointing to the TaskHistory class
        const locale = this.getAppLocale()
        this.serializer = (task: Task) => toHistoryRecord$(task, locale)
    }
}
